import * as React from 'react';

const LinkedIn = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zM8.4 18.3H5.57V9.8H8.4zM7 8.63h0a1.46 1.46 0 0 1-1.6-1.47A1.48 1.48 0 0 1 7 5.69a1.47 1.47 0 1 1 0 2.94zm11.6 9.68h-2.83v-4.56c0-1.14-.4-1.92-1.43-1.92a1.55 1.55 0 0 0-1.45 1 1.86 1.86 0 0 0-.1.69v4.76H10v-8.5h2.83V11a2.81 2.81 0 0 1 2.55-1.4c1.86 0 3.26 1.2 3.26 3.83z" />
  </svg>
);

export default LinkedIn;
